module.exports = __webpack_public_path__ + "img/cert-reset.6e00ec4d.svg";